document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('scent-quiz-form');
  const steps = Array.from(document.querySelectorAll('.quiz-step'));
  const submitButtons = Array.from(document.querySelectorAll('.submit-button'));
  const restartButton = document.querySelector('.restart-button');
  const loadingScreen = document.getElementById('loading-screen');

  let currentStep = 0; // Track the current step
  const answers = {}; // Store user answers

  const showLoadingScreen = (duration = 1000) => {
    loadingScreen.style.display = 'flex';
    setTimeout(() => {
      loadingScreen.style.display = 'none';
    }, duration);
  };

  const showStep = (stepIndex) => {
    steps.forEach((step, index) => {
      step.style.display = index === stepIndex ? 'block' : 'none';
    });
  };

  // Initialize the first step
  showStep(currentStep);

  // Navigate to the next step based on selected radio buttons
  steps.forEach((step, index) => {
    const radios = step.querySelectorAll('input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        const selectedValue = radio.value;
        const inputName = radio.name;

        // Save the answer
        answers[inputName] = selectedValue;
        console.log(`Step ${index + 1} answer:`, { [inputName]: selectedValue });

        // Determine next step based on "product_type"
        if (inputName === 'product_type') {
          if (selectedValue === 'single') {
            currentStep = 1; // Go to "Choose Gender" for Single Perfume
          } else if (selectedValue === 'bundle') {
            currentStep = 2; // Go to "Select Bundle Type" for Bundle
          }
        } else if (inputName === 'bundle_type' && answers.product_type === 'bundle') {
          currentStep = 3; // Go to "Fragrance Notes" for Bundle
        } else if (inputName === 'gender' && answers.product_type === 'single') {
          currentStep = 3; // Go to "Occasion" for Single Perfume
        } else {
          currentStep++; // Proceed to the next step for other inputs
        }

        // Show the next step
        showLoadingScreen();
        setTimeout(() => {
          showStep(currentStep);
        }, 1000);
      });
    });
  });

    // Highlight functionality and limit selection to 3 fragrance notes (checkboxes)
  const fragranceCheckboxes = document.querySelectorAll('input[name="fragrance_notes"]');
  
  fragranceCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const label = checkbox.closest('label');
      if (checkbox.checked) {
        label.style.backgroundColor = '#c0a65d';
        label.style.color = '#fff';
      } else {
        label.style.backgroundColor = '#1f1f1f';
        label.style.color = '#fff';
      }

      // Limit selection to 3
      const checkedCount = document.querySelectorAll('input[name="fragrance_notes"]:checked').length;
      
      if (checkedCount >= 3) {
        fragranceCheckboxes.forEach((cb) => {
          if (!cb.checked) {
            cb.disabled = true; // Disable unchecked checkboxes
            cb.closest('label').style.opacity = '0.6'; // Optional: Visually indicate disabled state
            cb.closest('label').style.cursor = 'not-allowed'; // Change cursor to indicate non-interactivity
          }
        });
      } else {
        fragranceCheckboxes.forEach((cb) => {
          cb.disabled = false; // Enable all checkboxes
          cb.closest('label').style.opacity = '1'; // Reset opacity
          cb.closest('label').style.cursor = 'pointer'; // Reset cursor
        });
      }
    });
  });

  // Submit button functionality
  submitButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const currentStepElement = steps[currentStep];
      const selectedCheckboxes = currentStepElement.querySelectorAll('input[name="fragrance_notes"]:checked');
      const selectedNotes = Array.from(selectedCheckboxes).map((cb) => cb.value.trim().toLowerCase());

      if (selectedNotes.length === 0) {
        alert('Please select at least one fragrance note.');
        return;
      }

      if (selectedNotes.length > 3) {
        alert('Please select up to 3 fragrance notes.');
        return;
      }

      answers.fragrance_notes = selectedNotes;
      console.log('Final answers:', answers);

      showLoadingScreen();
      setTimeout(() => {
        filterAndDisplayProducts(answers);
      }, 1000);
    });
  });

  // Restart button functionality
restartButton.addEventListener('click', () => {
    showLoadingScreen();
    setTimeout(() => {
        // Clear stored answers
        Object.keys(answers).forEach((key) => delete answers[key]);

        // Reset all inputs
        const inputs = form.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        inputs.forEach((input) => {
            input.checked = false; // Uncheck all radio buttons and checkboxes
            input.disabled = false; // Re-enable inputs
        });

        // Reset all labels (for styling reset)
        const labels = form.querySelectorAll('.quiz-options label');
        labels.forEach((label) => {
            label.style.backgroundColor = ''; // Reset background color
            label.style.color = ''; // Reset text color
        });

        // Reset current step to the first step
        currentStep = 0;
        showStep(currentStep);

        // Clear recommended products
        document.getElementById('recommended-products').innerHTML = '';

        console.log('Quiz restarted.');
    }, 1000);
});


  // Filter products and display results
  function filterAndDisplayProducts(answers) {
    let products = window.productsData || [];
    console.log('Total products:', products.length);

    if (answers.product_type === 'single') {
      products = filterSinglePerfume(products, answers);
    } else if (answers.product_type === 'bundle') {
      products = filterBundle(products, answers);
    }

    console.log('Filtered products:', products);
    displayResults(products);
  }

  function filterSinglePerfume(products, answers) {
    const { gender, occasion, fragrance_notes } = answers;
    return products.filter((product) => {
      if (product.tags.includes('bundle')) return false;

      const productGender = product.tags.includes(gender.toLowerCase());
      const productOccasion = product.tags.includes(occasion.toLowerCase());
      const productNotes = getMetafieldValues(product, 'custom', 'accords');

      const matches = fragrance_notes.filter((note) => productNotes.includes(note));
      return productGender && productOccasion && matches.length > 0;
    }).slice(0, 3);
  }

  function filterBundle(products, answers) {
    const { bundle_type, fragrance_notes } = answers;
    return products.filter((product) => {
      if (!product.tags.includes('bundle')) return false;

      const productBundleType = product.tags.includes(bundle_type.toLowerCase());
      const productNotes = getMetafieldValues(product, 'custom', 'accords');

      const matches = fragrance_notes.filter((note) => productNotes.includes(note));
      return productBundleType && matches.length > 0;
    }).slice(0, 2);
  }

  function getMetafieldValues(product, namespace, key) {
    const metafield = product.metafields?.[namespace]?.[key];
    if (!metafield || !Array.isArray(metafield)) return [];
    return metafield.map((value) => value.toLowerCase());
  }

  function displayResults(products) {
    const container = document.getElementById('recommended-products');
    container.innerHTML = ''; // Clear any previous results

    if (!products || products.length === 0) {
      // Fallback to "Makhsoos" product dynamically
      const fallbackHandle = 'makhsoos-customized-perfumes';
      const fallbackProduct = window.productsData.find((product) => product.handle === fallbackHandle);

      if (fallbackProduct) {
        const card = document.createElement('div');
        card.className = 'product-card';

        const img = document.createElement('img');
        img.src = fallbackProduct.images?.[0]?.src || window.defaultImage;
        img.alt = fallbackProduct.title;

        const title = document.createElement('h3');
        title.textContent = fallbackProduct.title;

        const link = document.createElement('a');
        link.href = `/products/${fallbackProduct.handle}`;
        link.textContent = 'View Product';

        card.appendChild(img);
        card.appendChild(title);
        card.appendChild(link);

        container.appendChild(card);
      } else {
        container.innerHTML = '<p>No matching products found. Please try different selections.</p>';
      }

      showStep(steps.length - 1);
      return;
    }

    products.forEach((product) => {
      const card = document.createElement('div');
      card.className = 'product-card';

      const img = document.createElement('img');
      img.src = product.images?.[0]?.src || window.defaultImage;
      img.alt = product.title;

      const title = document.createElement('h3');
      title.textContent = product.title;

      const link = document.createElement('a');
      link.href = `/products/${product.handle}`;
      link.textContent = 'View Product';

      card.appendChild(img);
      card.appendChild(title);
      card.appendChild(link);

      container.appendChild(card);
    });

    showStep(steps.length - 1);
  }
});
